
import Table from "./CommonUserTable";


function Admin() {
  return (
    <div>
      <Table role={2} />
    </div>
  );
}

export default Admin;
